import React from 'react'
import { ScaleLoader } from 'react-spinners';

function LoadingScene() {
    return (
        <div className="w-2/5 flex items-center justify-center h-full p-4">
            <ScaleLoader color="#36d7b7" />
        </div>
    );
}

export default LoadingScene;
